import React from 'react';
import { useLocation } from "react-router-dom";
import Link from '../Link';
import Image from '../Image';
import { ReactComponent as StarSolidIcon } from '../../assets/images/icons/star_solid.svg';



const DoctorCard = (props) => {
    const location = useLocation();
    return (
        <Link className="card card-doctor" to={props.Clicked || !props.link ? null : {pathname: props.link, state: { prevPath: location.pathname }}} onClick={props.Clicked ? props.Clicked : null}>
            {props.image ? 
                <Image 
                    className={`card-doctor--figure`}
                    src={props.image} 
                    alt={props.title ? props.title : ""}
                />
            : null}
            <div className="card-doctor--content">
                {props.title ? <h4 className="card-doctor--title">{props.title}</h4> : null}
                {props.subtitle ? 
                    <div className="text card-doctor--subtitle">
                        {props.subtitle}
                    </div>
                : null}
                {props.centres && props.centres.length > 0 ? 
                    <div className="card-doctor--tags">
                        {props.centres.map((centre, index) => {
                            return <div className="text text--tag bold" key={index}>
                                        {centre}
                                    </div>
                        })}
                    </div>
                : null}
            </div>
            {props.isFavourite ? 
                <div className="card-doctor--favourite">
                    <StarSolidIcon />
                </div>
            : null}
        </Link>
    );
};

export default DoctorCard;